export const LOGIN_USER = "USER_SUCCESS_LOGIN";
export const LOGOUT_USER = "USER_SUCCESS_LOGOUT";
